export {routesApp} from './routes'
export { LANGUAGE_OPTIONS, getLanguageName } from './languages'
export type { LanguageOption } from './languages'

export const API_URL = process.env.REACT_APP_API_URL;
export const NODE_ENV = process.env.NODE_ENV;

export const isDevEnv = NODE_ENV === "development";
export const isProdEnv = NODE_ENV === "production";